import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ServerService } from '../../../service/server/server.service';
import { MatTableDataSource } from '@angular/material/table';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ShopServiceComponent } from '../../../shop-service/shop-service.component';

@Component({
  selector: 'app-crm-task-detaile',
  templateUrl: './crm-task-detaile.component.html',
  styleUrls: ['./crm-task-detaile.component.scss']
})
export class CrmTaskDetaileComponent implements OnInit, OnDestroy {
  public isOnline: any;
  public loading = false;
  public subscription: Subscription;
  public err: string; public err_validation: boolean = false;
  public err_internet_text: string; public err_internet_validation: boolean;
  public server: any;
  coop: string;
  project: string;
  meter: string;
  floor: string;
  place: string;
  visit: number;
  date1_visit: string;
  title: string;
  title2: string;
  user_info: any;
  user_id: number;
  id: number;
  coop_title: string;
  project_title: string;
  visit_title: string;
  recipient: string;
  recipient_title: string;
  recipient2: string;
  recipient2_title: string;
  i: number = 0;
  comment: string;
  comment2: string;
  result: any;
  type_task: number;
  task_user_id: number;
  user_task_user: number;
  @ViewChild('myModal', { static: true }) myModal: any;
  list_task: any = [];
  list_sub_task: any = [];
  type_new_task: number;
  lang: number;
  dataSource2;
  task_id: number;
  public mat_table_selectedRow: any;
  public mat_table_hoverRow: any;
  displayedColumns2 = ['row', 'title2', 'comment2', 'creator', 'recipient', 'operation'];




  constructor(public serverService: ServerService, public router: Router, public matSnackBar: MatSnackBar
    , private dialog: MatDialog, private matDialogRef: MatDialogRef<CrmTaskDetaileComponent>
    , @Inject(MAT_DIALOG_DATA) private dialog_data: any) {

    if (dialog_data) {
      this.server = this.serverService.get_server();

      this.task_id = dialog_data.task_id;
      this.task_user_id = dialog_data.task_user_id;
      this.user_task_user = dialog_data.user_task_user;
      this.i = dialog_data.i;
      this.type_task = dialog_data.type_task;
      if (this.type_task == 2) {
        this.get_task();
      }

    }

  }//end consructor

  ngOnInit() {
    this.server = this.serverService.get_server();
    this.user_info = JSON.parse(<any>localStorage.getItem('user_info'));
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
    this.get_sub_task();
  }

  get_task() {
    if (this.serverService.check_internet()['status'] == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 297, id: this.task_id }).subscribe(
      (res) => {
        if (res['status'] == 1) {
          this.title = res['result'][0].user_task_title;
          this.coop_title = res['result'][0].crm_coop_title;
          this.coop = res['result'][0].user_task_coop;
          this.project_title = res['result'][0].crm_project_title;
          this.project = res['result'][0].user_task_project;
          this.meter = res['result'][0].user_task_meter;
          this.place = res['result'][0].user_task_place;
          this.visit_title = res['result'][0].crm_visit_title;
          this.visit = res['result'][0].user_task_visit;
          this.recipient_title = res['result'][0].recipient;
          this.recipient = res['result'][0].user_task_recipient;
          this.comment = res['result'][0].user_task_comment;


          this.date1_visit = res['result'][0].user_task_date1_visit;
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }


  get_sub_task() {
    if (this.serverService.check_internet()['status'] == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 307, task_id: this.task_id }).subscribe(
      (res) => {
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_sub_task.push(res['result'][i]);
          }
          console.log(this.list_sub_task);
          this.dataSource2 = new MatTableDataSource(this.list_sub_task);
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  save() {
    if (this.type_task == 2) {
      this.update();
    }
    else {
      this.insert();
    }
  }


  insert() {
    if (this.serverService.check_internet()['status'] == false) {
      this.err_internet_validation = true;
      this.err_internet_text = this.serverService.check_internet()['title'];
      return;
    }//end if
    else { this.err_internet_validation = false; }
    this.loading = true;
    var obj = {
      address: 301
      , user_id: this.user_id
      , id: this.task_id
      , task_user_id: this.task_user_id
      , title: this.title
      , coop: this.coop
      , project: this.project
      , meter: this.meter
      , place: this.place
      , visit: this.visit
      , recipient: this.recipient
      , date1_visit: this.date1_visit
      , comment: this.comment
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res) => {
        if (res['status'] == 1 && res['num'] == 1) {
          this.matDialogRef.close({ result: res['result'][0] });
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در ذخیره";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
        }
      }
    );
  }//end insert

  update() {
    if (this.serverService.check_internet()['status'] == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      address: 282
      , user_id: this.user_id
      , task_user_id: this.task_user_id
      , title: this.title
      , comment: this.comment
      , id: this.task_id
      , coop: this.coop
      , project: this.project
      , meter: this.meter
      , place: this.place
      , visit: this.visit
      , recipient: this.recipient
      , date1_visit: this.date1_visit
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res) => {
        if (res['status'] == 1) {
          this.result = res['result'][0];
          this.close();
          var pe_message = "با موفقیت ثبت شد";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }


  add(type) {
    this.type_new_task = type;
    this.myModal.open();
  }



  insert_new_task() {
    if (this.serverService.check_internet()['status'] == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      address: 301
      , type: 2
      , user_id: this.user_id
      , task_id: this.task_id
      , task_user_id: this.task_user_id
      , 'user_task_user': this.user_task_user
      , title: this.title2
      , comment: this.comment2
      , recipient: this.recipient2
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res) => {
        if (res['status'] == 1) {
          this.list_sub_task.unshift(res['result'][0]);
          this.dataSource2 = new MatTableDataSource(this.list_sub_task);
          this.myModal.close();
          var pe_message = "با موفقیت ثبت شد";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  change_task() {

  }

  delete() {

  }


  update_new_task(type) {
    if (this.serverService.check_internet()['status'] == false) {
      this.err_internet_validation = true;
      this.err_internet_text = this.serverService.check_internet()['title'];
      return;
    }//end if
    else { this.err_internet_validation = false; }
    this.loading = true;
    var obj = {
      address: 308
      , type: 2
      , user_id: this.user_id
      , task_id: this.task_id
      , task_user_id: this.task_user_id
      , 'user_task_user': this.user_task_user
      , title: this.title2
      , comment: this.comment2
      , recipient: this.recipient2
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res) => {
        if (res['status'] == 1) {
          for (var i = 0; i < this.list_sub_task.length; i++) {
            if (this.list_sub_task[i].user_task_id == this.id) {
              this.list_sub_task[i].user_task_title = res['result'][0].user_task_title;
              this.list_sub_task[i].user_task_comment = res['result'][0].user_task_comment;
              this.list_sub_task[i].recipient = res['result'][0].recipient;
            }//end if
          }//end for
          this.dataSource2 = new MatTableDataSource(this.list_sub_task);
          var pe_message = "با موفقیت ذخیره شد";
          var pe_action = "بستن";
          this.recieve_message(true, 'Done successfully', pe_message, 1, 'close', pe_action);
        }//end if
        else if (res['status'] == 4) {
          var pe_message = "عنوان  مي بايست منحصر به فرد باشد";
          var pe_action = "بستن";
          this.recieve_message(true, 'The title should be unique', pe_message, 1, 'close', pe_action);
        }
        else {
          var pe_message = "خطا در ذخیره";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    );
  }


  load_service(id, type) {
    const dialogRef = this.dialog.open(ShopServiceComponent, {
      'width': '40rem',
      'height': 'auto',
      data: { id: id }
    });
    dialogRef.afterClosed().subscribe(
      (result) => {
        if (result) {
          if (id == 57) { this.coop = result.id; this.coop_title = result.title; }
          if (id == 58) { this.project = result.id; this.project_title = result.title; }
          if (id == 59) { this.visit = result.id; this.visit_title = result.title; }
          if (id == 24 && type == 1) { this.recipient = result.id; this.recipient_title = result.title; }
          if (id == 24 && type == 2) { this.recipient2 = result.id; this.recipient2_title = result.title; }
        }
      }
    )
  };

  close() {
    this.matDialogRef.close({ result: this.result, i: this.i });
  }
  //**************************************************
  recieve_message(validation, en_message, pe_message, type, en_action, pe_action) {
    this.err_internet_validation = false;
    if (type == 1) this.loading = false;
    if (validation == true) {
      this.matSnackBar.open(pe_message, pe_action, { duration: 2000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}